import React, { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import MuiMultiSelectionDropDown from '@shared/components/MuiMultiSelectionDropDown';
import { userPrivileges } from '@apollo-internal/cache';
import NotificationList from './NotificationList';

/**
 * @typedef {object} NotificationSectionNotificationConfig
 * @property {string} title
 * @property {string} emptyListText
 * @property {Array<Object>} filterOptions
 * @property {Map} notificationComponentMap
 */

/**
 * @typedef {object} NotificationSectionProps
 * @property {Array<*>} [notifications]
 * @property {NotificationSectionNotificationConfig} notificationConfig
 * @property {boolean} [loading]
 */

/**
 * @param {NotificationSectionProps} props
 */
const NotificationSection = props => {
  const { notifications, notificationConfig, loading } = props;
  const { title, emptyListText, filterOptions, notificationComponentMap } = notificationConfig;

  const privileges = useReactiveVar(userPrivileges);

  const [selectedFilters, setSelectedFilters] = useState([]);

  const filteredNotifications = notifications.filter(
    n => !selectedFilters.length || selectedFilters.includes(n.Type)
  );

  const filteredOptions = filterOptions.filter(
    option => !option.shouldDisplay || option.shouldDisplay(privileges)
  );

  const handleSelectedFilterChange = selectedFilterOptions => {
    setSelectedFilters(selectedFilterOptions.map(x => x.value));
  };

  return (
    <div className='notifications-list'>
      <div className='notifications-list-header'>
        <h2>
          <strong>{title}</strong>
        </h2>
        <MuiMultiSelectionDropDown
          id='multi-drop-down-auto-complete'
          inputLabel={`${title} Notifications Filter`}
          options={filteredOptions}
          setSelectedValue={handleSelectedFilterChange}
          limitTags={3}
        />
      </div>
      {!loading && !filteredNotifications.length ? (
        <>
          <hr />
          <div className='notification-list__empty'>{emptyListText}</div>
        </>
      ) : (
        <NotificationList
          loading={loading}
          notifications={filteredNotifications}
          notificationComponentMap={notificationComponentMap}
        />
      )}
    </div>
  );
};

export default NotificationSection;
